import { fetchHubLoginUrl, fetchHubStatus } from "../services/hub-settings";
import { savePendingRedirect } from "./post-login-redirect";

let isRedirecting = false;

// Safety-net reset: if the browser navigation this triggers doesn't
// actually happen (popup/navigation blocked, user cancels it), the latch
// must not stay stuck forever and block every future redirect attempt for
// the rest of this page's lifetime.
const LATCH_RESET_MS = 5000;

export const redirectToLoginHub = async (
  reason: string | null = null,
  savePendingUrl = true
) => {
  const currentPath = window.location.pathname;
  if (currentPath === "/not_found" || isRedirecting) return;

  isRedirecting = true;
  setTimeout(() => {
    isRedirecting = false;
  }, LATCH_RESET_MS);

  if (savePendingUrl) {
    savePendingRedirect(`${window.location.pathname}${window.location.search}`);
  }

  const loginUrl = (await fetchHubLoginUrl()) ?? "/";
  const isLoginUrlValid = loginUrl !== "/" && /^https?:\/\//i.test(loginUrl);

  window.name = reason ? JSON.stringify({ reason }) : "";

  window.location.href = isLoginUrlValid ? loginUrl : await destinationWhenHubUrlUnavailable();
};

// No usable Hub login URL: still worth checking whether the permanent
// local fallback mode (see login.component.tsx) is available before
// giving up on `/not_found` -- an environment with no Hub at all should
// land its users on the login form it actually has.
export const destinationWhenHubUrlUnavailable = async (): Promise<string> => {
  const status = await fetchHubStatus();
  return status?.local_fallback_available ? "/login" : "/not_found?reason=hub_url_unavailable";
};
